import React from "react";
import { useParams } from "react-router-dom";
import masterProgrammesData from "../../../data/masterProgrammesData";
import TopSection from "./components/topSection";
import MastersProgrammeNav from "./mastersProgrammeNav";
import ProgramOverview from "./components/programOverview";
import LearningOutcomes from "./components/learningOutcomes";
import ProgrammeFees from "./components/programmeFees";
import HowToPay from "./components/howToPay";
import ItRequirements from "./components/itRequirements";
import CareerOpportunities from "./components/careerOpportunities";
import LeadershipModules from "./components/modules/LeadershipModules";
import GenderLeadershipModules from "./components/modules/GenderLeadershipModules";
import DiplomacyModules from "./components/modules/DiplomacyModules";
import ConsultingModules from "./components/modules/ConsultingModules";
import LeadershipEntryRequirements from "./components/entryRequirements/LeadershipEntryRequirements";
import GenderLeadershipEntryRequirements from "./components/entryRequirements/GenderLeadershipEntryRequirements";
import DiplomacyEntryRequirements from "./components/entryRequirements/DiplomacyEntryRequirements";
import ConsultingEntryRequirements from "./components/entryRequirements/ConsultingEntryRequirements";
import LeadershipDesign2Modern from "./LeadershipDesign2Modern";

const moduleComponents = {
  leadership: LeadershipModules,
  "womens-gender-leadership": GenderLeadershipModules,
  "diplomacy-international-relation": DiplomacyModules,
  consulting: ConsultingModules,

  "postgraduate-certificate-leadership": LeadershipModules,
  "postgraduate-diploma-leadership": LeadershipModules,
};

const entryRequirementsComponents = {
  leadership: LeadershipEntryRequirements,
  "womens-gender-leadership": GenderLeadershipEntryRequirements,
  "diplomacy-international-relation": DiplomacyEntryRequirements,
  consulting: ConsultingEntryRequirements,

  "postgraduate-certificate-leadership": LeadershipEntryRequirements,
  "postgraduate-diploma-leadership": LeadershipEntryRequirements,
};

const MasterProgrammesTemplate = () => {
  const { masterProgramme } = useParams(); 

  const mastersprogram = masterProgrammesData.find(
    (mastersprogram) => mastersprogram.id === masterProgramme
  );

  if (!mastersprogram) {
    return (
      <h1 className="mt-36 text-center justify-center items-center bg-red-700 text-white max-w-52 mx-auto p-2 rounded-md">
        Course not found
      </h1>
    );
  }

  if (mastersprogram.id === "leadership") {
    return <LeadershipDesign2Modern mastersprogram={mastersprogram} />;
  }

  const SpecificModuleComponent =
    moduleComponents[mastersprogram.id] ||
    (() => <div>No specific module available.</div>);

  const SpecificEntryRequirementsComponent =
    entryRequirementsComponents[mastersprogram.id] ||
    (() => <div>No specific entry requirements available.</div>);

  return (
    <div>
      <TopSection
        title={mastersprogram.title}
        topItems={mastersprogram.topItems}
        blab={mastersprogram.blab}
        topBgImage={mastersprogram.topBgImage}
      />

      <MastersProgrammeNav />

      <div className="bg-sddarkgray">
        <div className="max-w-6xl mx-auto md:px md:flex justify-center items-start md:space-x-4 ">
          <div className="flex-1 ">
            <ProgramOverview overview={mastersprogram.overview} />
          </div>

          <div className="h-1 w-52 bg-sdorange md:w-1 md:h-52 md:self-center justify-self-center rounded-2xl"></div>

          <div className="flex-1 ">
            <LearningOutcomes />
          </div>
        </div>
      </div>

      <SpecificModuleComponent modules={mastersprogram.modules} />

      <SpecificEntryRequirementsComponent
        entryRequirements={mastersprogram.entryRequirements}
      />

      <ProgrammeFees />

      <CareerOpportunities
        careerOpportunities={mastersprogram.careerOpportunities}
      />
    </div>
  );
};

export default MasterProgrammesTemplate;
